/*
 * @Date: 2023-10-30 19:39:32
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-06 20:54:40
 * @FilePath: /Client/src/common/utils.ts
 * @Description:
 */

import { countries, CountriesEnum, countryType, japanStationCor2Country, koreaStationCor2Country, ukStationCor2Country } from './const'
import store, { useSite2Code, isJA } from '@/store'

/** 获取code列表列表 */
export const getCountryCodeList = () => {
  const site = useSite2Code()
  let list: countryType[] = []
  switch (site) {
    case CountriesEnum.Japan:
      list = countries.filter(i => japanStationCor2Country.includes(i.key))
      break
    case CountriesEnum.Korea:
      list = countries.filter(i => koreaStationCor2Country.includes(i.key))
      break
    case CountriesEnum.UK:
      list = countries.filter(i => ukStationCor2Country.includes(i.key) && i.mobileAreaCode)
      break
    default:
      break
  }
  return list
}

type ShopItem = {
  productTag: number;
  platformType: string;
  countryProductTag: number;
}

/** 针对国家货盘判断tag */
export const calType = (item: any) => {
  if (item.carefullySelected === 1) {
    return 'choice'
  }
  // 1688国家货盘
  if (isJA() && item.countryProductTag === 1) {
    return 'NAM'
  } else {
    // 1688精选货盘
    if (item.productTag === 1) {
      return 'AMT'
    }
  }
  return item.platformType
}
